/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_Team_ManagementInputs */



/**
* | output |
* | --- |
* | "Open team management" |
*
* @param {Open_Team_ManagementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_team_management = /** @type {((inputs?: Open_Team_ManagementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Team_ManagementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir la gestion d'équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offenes Teammanagement")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestione aperta del team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открытое управление командой")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestión de equipos abiertos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开放式团队管理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オープンチーム管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खुली टीम प्रबंधन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gestão de equipe aberta")
	return /** @type {LocalizedString} */ ("Open team management")
});